import { render, staticRenderFns } from "./AppointmentsSidebar.vue?vue&type=template&id=58556fd2&scoped=true"
import script from "./AppointmentsSidebar.vue?vue&type=script&lang=js"
export * from "./AppointmentsSidebar.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsSidebar.vue?vue&type=style&index=0&id=58556fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58556fd2",
  null
  
)

export default component.exports